var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgBriefcase = function SvgBriefcase(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Briefcase' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38,40 L46,40 L46,10 L38,10 L38,40 Z M2,40 L10,40 L10,10 L2,10 L2,40 Z M33.78,8 L48,8 L48,42 L0,42 L0,8 L14.22,8 L15.272,3.788 C15.83,1.558 17.824,0 20.123,0 L27.877,0 C30.176,0 32.17,1.558 32.728,3.788 L33.78,8 Z M17.212,4.272 L16.28,8 L31.72,8 L30.788,4.272 C30.453,2.935 29.256,2 27.877,2 L20.123,2 C18.744,2 17.547,2.935 17.212,4.272 Z M12,40 L36,40 L36,10 L12,10 L12,40 Z"
  }));
};
SvgBriefcase = pure(SvgBriefcase);
SvgBriefcase.displayName = 'SvgBriefcase';
export default SvgBriefcase;